import type { MergedDoctor } from "@/lib/doctor-merge";

type Props = {
  doctor: Pick<MergedDoctor, "name" | "imageUrl" | "gender">;
  className?: string;
  imgClassName?: string;
};

function initials(name: string) {
  const cleaned = name.replace(/^Dr\.?\s+/i, "").trim();
  const parts = cleaned.split(/\s+/).filter(Boolean);
  const a = parts[0]?.[0] ?? "";
  const b = parts[parts.length - 1]?.[0] ?? "";
  return (a + b).toUpperCase();
}

export function DoctorPortrait({ doctor, className = "", imgClassName = "" }: Props) {
  if (doctor.imageUrl) {
    return (
      <div className={`bg-doctor-gradient ${className}`}>
        <img
          src={doctor.imageUrl}
          alt={doctor.name}
          loading="lazy"
          width={448}
          height={448}
          className={`h-full w-full object-cover ${imgClassName}`}
        />
      </div>
    );
  }
  return (
    <div
      className={`bg-doctor-gradient flex items-center justify-center ${className}`}
      style={{ color: "#1b3358" }}
      aria-label={doctor.name}
    >
      <span className="font-display text-3xl font-semibold tracking-wide opacity-80 sm:text-4xl">
        {initials(doctor.name) || "Dr"}
      </span>
    </div>
  );
}
